/**
 * MainLayout Component - Public pages layout
 */
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@components/layout/Header.jsx';
import Footer from '@components/layout/Footer.jsx';
import PromoBannerDisplay from '@components/common/PromoBannerDisplay';
import HelpWidget from '@components/common/HelpWidget';

const MainLayout = () => {
  return (
    <div className="main-layout">
      <PromoBannerDisplay placement="top_bar" maxBanners={1} />
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
      {/* "Need help?" — WhatsApp chat or request a callback. */}
      <HelpWidget />
    </div>
  );
};

export default MainLayout;
